export interface DateWindow {
    startDate: string | null;
    endDate: string | null;
}

// Sentinel bounds standing in for -infinity/+infinity so a null start/end can be compared with a
// simple lexicographic string comparison (dates are yyyy-mm-dd, which sorts correctly as strings).
export const MIN_DATE = '0001-01-01';
export const MAX_DATE = '9999-12-31';
export const DEFAULT_NEWNESS_LOOKBACK_DAYS = 90;

const normalizeDatePrefix = (value: string): string => value.slice(0, 10);

export const normalizeStartDate = (startDate: string | null | undefined): string | null => {
    if (!startDate) {
        return null;
    }

    const normalizedStartDate = normalizeDatePrefix(startDate);

    if (normalizedStartDate === MIN_DATE || normalizedStartDate.startsWith('0001-')) {
        return null;
    }

    return startDate;
};

export const normalizeEndDate = (endDate: string | null | undefined): string | null => {
    if (!endDate) {
        return null;
    }

    const normalizedEndDate = normalizeDatePrefix(endDate);

    if (normalizedEndDate === MAX_DATE || normalizedEndDate.startsWith('9999-')) {
        return null;
    }

    return endDate;
};

// Two windows overlap when neither ends before the other starts. A null start behaves as
// -infinity, a null end as +infinity, so two "always active" windows always overlap.
export const windowsOverlap = (a: DateWindow, b: DateWindow): boolean => {
    const aStart = a.startDate ?? MIN_DATE;
    const aEnd = a.endDate ?? MAX_DATE;
    const bStart = b.startDate ?? MIN_DATE;
    const bEnd = b.endDate ?? MAX_DATE;

    return aStart <= bEnd && bStart <= aEnd;
};
